import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "stock/units";

export const GET_STOCK_UNIT_OPTIONS = "getStockUnitOptions";
export const GET_STOCK_UNITS = "getStockUnits";
export const GET_STOCK_UNIT = "getStockUnit";
export const CREATE_STOCK_UNIT = "createStockUnit";
export const UPDATE_STOCK_UNIT = "updateStockUnit";
export const DELETE_STOCK_UNIT = "deleteStockUnit";

const actions = {
  [GET_STOCK_UNIT_OPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_UNITS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_UNIT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_UNIT](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_UNIT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_UNIT](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data ?? error));
    });
  },
};

export default {
  actions,
};
